import { ReportIds } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ProductionReportConfig } from './production-reports.models';
import {
  buildReportVariables,
  PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
} from './production-reports.config.shared';

export const PRODUCTION_MGA_SUBMIT_REPORT: ProductionReportConfig = {
  id: ReportIds.mgaSubmit,
  name: 'MGA Submitted',
  description: 'MGA Submitted report',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'MGA Submitted',
    subtitle: 'Leaders Bulletin',
  },
  columnConfig: {
    agency_name: {
      displayName: 'MGA',
      format: 'text',
    },
    premium: {
      displayName: 'Premium',
      format: 'currency',
      sumTotal: true,
      width: '200px',
    },
    count: {
      displayName: 'Count',
      format: 'decimal1',
      sumTotal: true,
      width: '150px',
    },
  },
  variables: buildReportVariables(ReportIds.mgaSubmit),
};

export const PRODUCTION_PERSONAL_SUBMIT_REPORT: ProductionReportConfig = {
  id: ReportIds.personalSubmit,
  name: 'Personal Submitted',
  description: 'Personal Submitted report',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'Personal Production Submitted',
    subtitle: 'Leaders Bulletin',
  },
  columnConfig: {
    agent: {
      displayName: 'Agent',
      format: 'text',
    },
    mga: {
      displayName: 'MGA',
      format: 'text',
    },
    premium: {
      displayName: 'Premium',
      format: 'currency',
      sumTotal: true,
      width: '100px',
    },
    count: {
      displayName: 'Count',
      format: 'decimal1',
      sumTotal: true,
      width: '75px',
    },
  },
  variables: buildReportVariables(ReportIds.personalSubmit),
};

export const PRODUCTION_RMD_SUBMIT_REPORT: ProductionReportConfig = {
  id: ReportIds.rmdSubmit,
  name: 'RMD Submitted',
  description: 'RMD Submitted report',
  template: {
    ...PRODUCTION_REPORTS_DEFAULT_TEMPLATE,
    title: 'RMD Submitted Report',
    subtitle: 'Leaders Bulletin',
  },
  columnConfig: {
    rmd: {
      displayName: 'RMD',
      format: 'text',
    },
    premium: {
      displayName: 'Premium',
      format: 'currency',
      sumTotal: true,
      width: '100px',
    },
    count: {
      displayName: 'Count',
      format: 'decimal1',
      sumTotal: true,
      width: '100px',
    },
  },
  variables: buildReportVariables(ReportIds.rmdSubmit),
};
